<div class="facility-management-container">
  <!-- Header with filters similar to orders -->
  <div class="mobile-order-controls">
    <div class="mobile-top-row">
      <div class="mobile-filter-buttons">
        <button
          mat-icon-button
          class="refresh-button"
          (click)="refreshData()"
          matTooltip="Refresh"
        >
          <mat-icon>refresh</mat-icon>
        </button>

        @if (canExport) {
        <button mat-icon-button matTooltip="Export Data" (click)="openExportDialog()">
          <mat-icon>get_app</mat-icon>
        </button>
        } @if (canAddFacility && !isActivityCheck) {
        <button
          mat-raised-button
          color="primary"
          (click)="isRoleBasedUser ? goToAddFacilityPage() : openAddFacilityDialog()"
        >
          <mat-icon>add</mat-icon>
          Add Facility
        </button>
        }
      </div>

      @if (report) {
      <div class="activity-period-table-container">
        <table class="activity-period-table">
          <thead>
            <tr>
              <th></th>
              <th>Received</th>
              <th>Sent</th>
              <th>Last Received</th>
              <th>Last Sent</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Today</td>
              <td>{{ report.count_received_today || 0 }}</td>
              <td>{{ report.count_sent_today || 0 }}</td>
              <td>{{ report.last_DateReceived_today || '' }}</td>
              <td>{{ report.last_DateSent_today || '' }}</td>
            </tr>
            <tr>
              <td>
                <input
                  type="date"
                  [(ngModel)]="customDateFrom"
                  (change)="onCustomDateRangeChange()"
                  style="margin-left: 8px; max-width: 120px"
                  placeholder="From"
                />
                <span style="margin: 0 4px">to</span>
                <input
                  type="date"
                  [(ngModel)]="customDateTo"
                  (change)="onCustomDateRangeChange()"
                  style="max-width: 120px"
                  placeholder="To"
                />
              </td>
              <td>{{ report.count_received_custom || 0 }}</td>
              <td>{{ report.count_sent_custom || 0 }}</td>
              <td>{{ report.last_DateReceived_custom || '' }}</td>
              <td>{{ report.last_DateSent_custom || '' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      }

      <div class="col-filter-right">
        <!-- Search Type Select -->
        <div class="search-type-part">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-type-select">
            <mat-label>Search by</mat-label>
            <mat-select [(ngModel)]="searchType" (selectionChange)="onSearchTypeChange()">
              <mat-option value="facility_id">ID</mat-option>
              <mat-option value="facility_name">Name</mat-option>
              <mat-option value="facility_to_approve">To Approve</mat-option>
              @if (showAgreementPendingStatus) {
              <mat-option value="facility_agreement_pending">Agreement Pending</mat-option>
              }
              <mat-option value="facility_to_activate">To Activate</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="search-part">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
            <input
              matInput
              [value]="searchTerm"
              (input)="onSearchInput($event)"
              [disabled]="isSearchDisabled"
              [placeholder]="getSearchPlaceholder()"
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>

        <!-- Group filter -->
        @if (!isRoleBasedUser) {
        <div class="mobile-filter-buttons search-group-part">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-field">
            <mat-label>Filter by Group</mat-label>
            <mat-select [(ngModel)]="selectedGroupFilter" (selectionChange)="applyFilter()">
              @for (group of referralGroups; track group) {
              <mat-option [value]="group.value">
                {{ group.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Table Container with your existing styling -->
  <div class="table-container">
    <div class="table-inner">
      <mat-table [dataSource]="dataSource" class="facilities-table" matSort>
        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            <div
              class="status-indicator"
              [style.background-color]="
                facility.approved === 0
                  ? '#757575'
                  : getStatusColor(facility.last_request?.status)
              "
              [matTooltip]="
                facility.approved === 0 ? 'Facility not approved' : 'Facility status'
              "
            >
              <mat-icon>{{
                facility.approved === 0
                  ? 'pending'
                  : getStatusIcon(facility.last_request?.status)
              }}</mat-icon>
            </div>
          </mat-cell>
        </ng-container>

        <!-- Facility ID Column -->
        <ng-container matColumnDef="FacilityID">
          <mat-header-cell *matHeaderCellDef>Facility ID</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            <span class="facility-id" [matTooltip]="facility.FacilityID">
              {{ facility.FacilityID }}
            </span>
          </mat-cell>
        </ng-container>

        <!-- Clinic Name Column -->
        <ng-container matColumnDef="ClinicName">
          <mat-header-cell *matHeaderCellDef>Clinic Name</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            <div class="clinic-name">
              {{ facility.ClinicName }}
            </div>
          </mat-cell>
        </ng-container>

        <!-- Account Manager Column -->
        <ng-container matColumnDef="accountManager">
          <mat-header-cell *matHeaderCellDef>Account Manager</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            {{ facility.account_manager_name || '—' }}
          </mat-cell>
        </ng-container>

        <!-- Notes Column -->
        <ng-container matColumnDef="notes">
          <mat-header-cell *matHeaderCellDef>Notes</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            <span class="notes-cell" [matTooltip]="facility.notes">{{
              facility.notes || '—'
            }}</span>
          </mat-cell>
        </ng-container>

        <!-- Last Request From Facility Column -->
        <ng-container matColumnDef="lastRequestFromFacility">
          <mat-header-cell *matHeaderCellDef>Last Request Received</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            @if (facility.last_request?.to_facility?.date_received) {
            <div>
              <div class="date-info">
                {{ formatDate(facility.last_request.to_facility.date_received) }}
              </div>
              <div class="time-ago">{{ facility.last_request.to_facility.inactivity }}</div>
            </div>
            } @else {
            <span class="no-data-text">No data</span>
            }
          </mat-cell>
        </ng-container>

        <!-- Last Request To Group Column -->
        <ng-container matColumnDef="lastRequestToGroup">
          <mat-header-cell *matHeaderCellDef>Last Request Sent</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            @if (facility.last_request?.to_group?.date_sent) {
            <div>
              <div class="date-info">
                {{ formatDate(facility.last_request.to_group.date_sent) }}
              </div>
              <div class="time-ago">{{ facility.last_request.to_group.inactivity }}</div>
            </div>
            } @else {
            <span class="no-data-text">No data</span>
            }
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let facility">
            <div class="action-buttons">
              @if ((!canEditFacility && facility.approved !== 0) || isActivityCheck) {
              <span class="filler"></span>
              } @if (facility.approved === 0 && !isActivityCheck) {
              <mat-icon
                class="has-link approve-icon"
                matTooltip="Approve Facility"
                (click)="approveFacility(facility)"
                style="color: #4caf50"
              >
                check_circle
              </mat-icon>
              } @if (searchType !== 'facility_agreement_pending') {
              <mat-icon
                class="has-link"
                matTooltip="Edit Facility"
                (click)="editFacility(facility)"
              >
                edit
              </mat-icon>
              }

              <span class="action-spacer"></span>

              <mat-icon
                class="has-link"
                matTooltip="Check Activity"
                (click)="checkActivity(facility)"
              >
                assessment
              </mat-icon>

              <span class="action-spacer"></span>

              @if (canDeleteFacility && !isActivityCheck) {
              <mat-icon
                class="has-link"
                matTooltip="Delete Facility"
                (click)="deleteFacility(facility)"
                style="color: #f44336"
              >
                delete
              </mat-icon>
              } @if (!canDeleteFacility || isActivityCheck) {
              <span class="filler"></span>
              }
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <!-- Loading spinner -->
      @if (isLoading) {
      <mat-spinner></mat-spinner>
      }

      <!-- No data message -->
      @if (!isLoading && dataSource.data.length === 0) {
      <div class="text-center" style="padding: 40px">
        <mat-icon style="font-size: 48px; color: #ccc">inbox</mat-icon>
        <p>
          {{
            selectedGroupFilter
              ? 'No facilities found for the selected group'
              : 'Select a Referral Group'
          }}
        </p>
      </div>
      }
    </div>

    <!-- Paginator with your styling -->
    <div class="custom-paginator">
      <div class="grow"></div>
      <div class="custom-paginator_options-hold">
        <span>Items per page:</span>
        <mat-select
          [(ngModel)]="pageSize"
          (selectionChange)="
            onPageChange({ pageIndex: 0, pageSize: pageSize, length: totalItems })
          "
        >
          @for (option of pageSizeOptions; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
          }
        </mat-select>
        <span style="margin: 0 20px">
          {{ (currentPage - 1) * pageSize + 1 }} –
          {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }}
        </span>
        <button
          mat-icon-button
          [disabled]="currentPage === 1"
          (click)="onPageChange({ pageIndex: 0, pageSize: pageSize, length: totalItems })"
        >
          <mat-icon>first_page</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="currentPage === 1"
          (click)="
            onPageChange({
              pageIndex: currentPage - 2,
              pageSize: pageSize,
              length: totalItems
            })
          "
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="currentPage * pageSize >= totalItems"
          (click)="
            onPageChange({ pageIndex: currentPage, pageSize: pageSize, length: totalItems })
          "
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="currentPage * pageSize >= totalItems"
          (click)="
            onPageChange({
              pageIndex: Math.ceil(totalItems / pageSize) - 1,
              pageSize: pageSize,
              length: totalItems
            })
          "
        >
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
